import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea6a03da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = {
  key: 0,
  class: "body"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "头像：")
], -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "姓名：")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "用户名：")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "身份证号：")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "手机号码：")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "民族：")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "状态：")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1))
const _hoisted_12 = { class: "body-bottom" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "项目名称：")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "参见单位：")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "部门：")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "班组：")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "岗位：")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "角色：")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "邮箱：")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "安全教育资料：")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_uploader = _resolveComponent("van-uploader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.userInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _hoisted_3,
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: _ctx.userInfo.photoUrl
                }, null, 8, _hoisted_4)
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_5,
              _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.name), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_6,
              _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.username), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_7,
              _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.idNo), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_8,
              _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.mobile), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_9,
              _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.nation), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_10,
              _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.status ? "正常" : "禁用"), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", null, [
          _hoisted_13,
          _createElementVNode("div", null, _toDisplayString(_ctx.$store.state.project.projectinfoDetail.name), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_14,
          _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.companyNames), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_15,
          _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.deptNames), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_16,
          _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.teamName), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_17,
          _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.stationName), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_18,
          _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.roleNames), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_19,
          _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.email), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_20,
          _createElementVNode("div", null, [
            _createVNode(_component_van_uploader, {
              fileList: _ctx.safeFileComputed,
              onClickPreview: _ctx.clickPreview,
              deletable: false,
              "max-count": _ctx.userInfo.safeFile.length
            }, null, 8, ["fileList", "onClickPreview", "max-count"])
          ])
        ])
      ])
    ])
  ]))
}